import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem("star_cookie_consent"));

  const decide = (v) => {
    localStorage.setItem("star_cookie_consent", v);
    setChoice(v);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: 0.8 }}
          className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-4xl mx-auto bg-surface border border-white/15 shadow-2xl p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-6">
            <Cookie className="w-8 h-8 text-gold shrink-0 hidden sm:block" strokeWidth={1.2} />
            <div className="flex-1 min-w-0">
              <p className="font-oswald uppercase text-xs tracking-[0.25em] text-gold mb-2">Cookie</p>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Questo sito utilizza esclusivamente cookie tecnici necessari al suo funzionamento. Non usiamo
                cookie di profilazione né di tracciamento. Maggiori dettagli nell'
                <Link to="/privacy" data-testid="cookie-privacy-link" className="text-gold underline underline-offset-2 hover:opacity-80 transition-opacity">
                  informativa privacy
                </Link>
                .
              </p>
            </div>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={() => decide("rejected")}
                data-testid="cookie-reject-btn"
                className="font-oswald uppercase tracking-[0.15em] text-xs px-5 py-3 border border-white/20 text-muted-foreground hover:border-gold hover:text-gold transition-colors duration-300"
              >
                Rifiuta
              </button>
              <button
                onClick={() => decide("accepted")}
                data-testid="cookie-accept-btn"
                className="btn-tracer bg-gold text-ink font-oswald uppercase tracking-[0.15em] text-xs px-6 py-3 hover:bg-gold-hover transition-colors duration-300"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
